import 'regenerator-runtime/runtime'
import useBSSLogger from '../hooks/useBSSLogger';
import getapiclient, { getwpclient } from '../lib/ajaxhelper';

const {logger} = useBSSLogger();

/**
 * ottiene il client_secret serve a mostrare i campi per il pagamento con carta tramite stripe
 * @returns 
 */
const getPaymentIntent =  async () => {

    const {data} = await getapiclient().post(`payments/stripepay`, undefined, {
        tokenRequired: true
    })

    logger.debug("payment intent da stripe", data);

    return data;
}

const confirmPayment = async (datiCarrello) => {
    const {esito} = await getapiclient().post(`payments/stripeconfirm`, {
        jsonobject: JSON.stringify(datiCarrello)
    })

    logger.debug("conferma pagamento stripe andato a buon fine?", esito);

    return esito
}

export {getPaymentIntent, confirmPayment}